<template>
  <dialog class="error-handler-dialog" ref="dialog">
    <h3>{{ $t(titleKey) }}</h3>
    <p>{{ $t(messageKey) }}</p>
    <div class="dialog-buttons">
      <button @click="cancel" class="dialog-btn">{{ $t('cancel') }}</button>
      
      <button @click="reconnect" class="dialog-btn primary">{{ $t('reconnect') }}</button>
    </div>
  </dialog>
</template>

<script>
export default {
  name: 'ErrorHandlerDialog',
  data() {
    return {
      type: '',
      titleKey: 'errorTitle',
      messageKey: 'errorMessage'
    };
  },
  methods: {
    showModal(type) {
      this.type = type;
      if (type === 'error') {
        this.titleKey = 'errorTitle';
        this.messageKey = 'errorMessage';
      } else {
        this.titleKey = 'closeTitle';
        this.messageKey = 'closeMessage';
      }
      this.$refs.dialog.showModal();
    },
    close() {
      this.$refs.dialog.close();
    },
    cancel() {
      this.$emit('cancel');
    },
    reconnect() {
      this.$emit('reconnect');
    },
    reload() {
      this.$emit('reload');
    }
  }
};
</script>

<style scoped>
.error-handler-dialog {
  padding: 20px;
  border-radius: 10px;
  background-color: var(--bg-color);
  color: var(--text-color);
  border: none;
  max-width: 320px;
  text-align: center;
  z-index: 1000;
}

.error-handler-dialog[open] {
  animation: fadeIn 0.3s ease;
}

.error-handler-dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.dialog-buttons {
  margin-top: 20px;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.dialog-btn {
  font-family: 'Montserrat';
  font-weight: 700;
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  background-color: var(--disabled-color);
  color: var(--text-color);
  cursor: pointer;
  transition: background-color 0.3s;
}

.dialog-btn:hover {
  background-color: var(--primary-hover);
  color: var(--text-color);
}

.dialog-btn.primary {
  background-color: var(--primary-color);
  color: var(--text-color);
}

.dialog-btn.primary:hover {
  background-color: var(--primary-hover);
}
</style>